import { createI18n } from 'vue-i18n'
let lang = "ru"
import messages from '@/lang/lang'

// Russian and Ukrainian have 4 plural forms (today/one/few/many, e.g. "1 день", "2 дня", "5 дней").
// vue-i18n's default rule only supports 3 buckets, so translations that need the
// 4th ("many") form must provide 4 pipe-separated segments - for anything with
// fewer segments we fall back to the default rule to avoid breaking it.
const russianPluralRule = (choice, choicesLength, orgRule) => {
    if(choicesLength < 4) return orgRule(choice, choicesLength)
    if(choice === 0) return 0
    const mod10 = choice % 10
    const mod100 = choice % 100
    if(mod10 === 1 && mod100 !== 11) return 1
    if(mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 2
    return 3
}

const i18n = createI18n({
    locale: lang,
    messages,
    pluralizationRules: {
        ru: russianPluralRule,
        uk: russianPluralRule,
    },
})

export default i18n
